module.exports = __webpack_public_path__ + "thx.5b10fd49.png";